import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { z } from 'zod'
import { installStaleChunkRecovery } from './lib/stale-chunk'
import { Providers } from './providers'
import { router } from './router'

// The Content-Security-Policy has no 'unsafe-eval': keep zod from probing `new Function` (JIT parsers).
z.config({ jitless: true })

// After a redeploy an open tab's lazy chunks are gone: reload once to pick up the new build.
installStaleChunkRecovery()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>
)
